var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{attrs:{"type":"text","id":"autocomplete","autocomplete":"on","placeholder":"Enter a location","plceholder":_vm.$t('customerInfoStep.customerForm.locationPlaceholder')},model:{value:(_vm.address.formatted),callback:function ($$v) {_vm.$set(_vm.address, "formatted", $$v)},expression:"address.formatted"}})
}
var staticRenderFns = []

export { render, staticRenderFns }